<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Tim Middlekauff, who hails from the Midwest, received a degree in marketing from Indiana University. Though his fondness for writing began in junior high, his penchant for story telling dates back earlier than that. These coupled to form a dream of one day writing a book of his own. His son’s life-threatening accident was the impetus for not delaying any further in bringing this dream to life. He hopes everyone who reads <em>The 12</em> enjoys it as much as he enjoyed telling the story.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0abe97c3